export const POLL_ROOT = "/poll";
